var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSino(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.56909 17.0101L5.68809 17.3551C6.10009 18.5521 7.40409 19.1881 8.60109 18.7761V18.7761C9.79809 18.3641 10.4341 17.0601 10.0221 15.8631L9.90309 15.5181",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98521 3.20403L6.68621 2.33603C6.35621 1.37903 5.31321 0.870035 4.35521 1.20003V1.20003C3.39821 1.53003 2.88921 2.57303 3.21821 3.53003L3.51721 4.39803",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.55411 9.76604V9.76604C0.739106 7.40004 1.99711 4.82104 4.36311 4.00604L6.07711 3.41604C8.44311 2.60104 11.0221 3.85904 11.8371 6.22504V6.22504L12.7471 8.86904C12.9201 9.37104 13.2851 9.78304 13.7611 10.015L14.5761 10.412C15.0531 10.645 15.4181 11.057 15.5901 11.558V11.558C15.9301 12.545 15.4051 13.621 14.4181 13.961L4.28311 17.451C3.29611 17.791 2.22011 17.266 1.88011 16.279V16.279C1.70711 15.777 1.74111 15.228 1.97311 14.751L2.37011 13.936C2.60311 13.459 2.63611 12.91 2.46311 12.408L1.55411 9.76604Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSino);
export default __webpack_public_path__ + "static/media/sino.08a7893a7303c726e0ee1685add07f51.svg";
export { ForwardRef as ReactComponent };